var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImgDocChecked = function SvgImgDocChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 210,
    viewBox: "0 0 184 210",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0153 47.0208C8.97706 60.4746 4.31848 73.9995 0 87.7063C18.6501 133.596 44.1893 173.775 77.9858 210C112.549 189.721 147.113 169.449 181.677 149.17C131.184 111.466 101.5 62.8394 94.1761 0C67.4585 15.6762 40.7329 31.3525 14.0153 47.0208Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3912 74.2685C14.9249 78.7451 7.46638 83.2218 0 87.7064C4.31848 74.0075 8.97706 60.4825 14.0153 47.0288C16.4514 56.2115 19.2354 65.2993 22.3912 74.2685Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.913 147.817C180.333 140.77 178.276 133.485 173.467 127.284C165.692 117.263 153.227 110.983 140.715 110.786C151.891 124.168 164.973 136.475 179.913 147.817Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.913 147.817C164.981 136.483 151.891 124.168 140.715 110.786C134.648 110.691 128.582 112.02 123.022 115.065C106.626 124.034 99.7368 145.634 111.435 161.152C117.256 168.872 126.106 174.076 135.629 176.188C150.301 167.582 164.981 158.969 179.652 150.364C179.771 149.518 179.858 148.671 179.913 147.817Z",
    fill: "#909090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 87.7062L22.3912 74.2683L1.32876 90.9411L0 87.7062Z",
    fill: "#909090"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.125 122.436C188.21 137.116 184.343 158.581 167.907 168.12C151.124 177.864 127.206 173.198 115.112 158.099C102.964 142.937 109.212 121.147 125.347 111.695C142.083 101.895 164.158 107.899 176.125 122.436Z",
    fill: "#286DF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M150.198 120.933C148.711 131.041 147.422 141.181 146.212 151.329C139.695 150.095 136.436 149.486 129.99 148.244C129.634 150.039 129.452 150.941 129.104 152.736C137.781 154.397 142.178 155.204 150.934 156.881C152.318 145.151 153.765 133.43 155.347 121.724C153.275 121.408 152.247 121.249 150.198 120.933Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgDocChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "public/media/img_doc_checked.5735fdaa.svg";
export { ForwardRef as ReactComponent };